export enum SetSnowflakeWarehouseStatus {
    IDLE = 1,
    LOADING = 2,
    SUCCEEDED = 3,
    FAILED = 4
}

export const RESET_SET_DATAMEER_SNOWFLAKE_WAREHOUSE_ERRORS = 'ResetSetSnowflakeWarehouseErrors';
